export function dateFromString( date){
  // console.log('dateFromString given[' + date + ']')
  let matches = false;

  if (date.length == 4){
    matches = date.match(/([0-9]{2})([0-9]{2})/);
    // console.log('matches 4', matches);
    let d = new Date();
    // matches.splice(1, 0, parseInt( d.getFullYear() ));
    matches.splice(1, 0, d.getFullYear() );
    // console.log(matches);
  }
  else if (date.length == 6){
    matches = date.match(/([0-9]{2})([0-9]{2})([0-9]{2})/);
    // console.log('matches 6', matches);
  }
  else if (date.length == 8){
    matches = date.match(/([0-9]{4})([0-9]{2})([0-9]{2})/);
    // console.log('matches 8', matches);
  }

  if (matches != false && matches.length == 4){
    console.log('matches', matches);
    let ret = makeDateTime(parseInt(matches[1]), parseInt(matches[2]), parseInt(matches[3]), 23,59,59); //last second of the day
    console.log('matches result', ret);
    return ret;
  } else {
    console.log('had wrong matches', matches);
    return false;
  }
}

export function makeDate( yr, mn, dy ){
  if (yr < 100){
    yr += 2000;
  }
  return {
    year: yr,
    month: mn,
    day: dy,
    hour: 0,
    minute: 0,
    second: 0
  }
}
export function makeDateTime( yr, mn, dy, hr, mi, sc){
  if (yr < 100){
    yr += 2000;
  }
  return {
    year: yr,
    month: mn,
    day: dy,
    hour: hr,
    minute: mi,
    second: sc
  }
}
export function getNow(){
  let d = new Date();
  return {
    year: d.getFullYear(),
    month: d.getMonth()+1, //0=january+1
    day: d.getDate(),
    hour: d.getHours(),
    minute: d.getMinutes(),
    second: d.getSeconds()
  }
}

export function addTime( date, toAdd ){
  let nms = 0;
  // console.log( 'addTime date', date);
  // console.log( 'addTime toAdd', toAdd);
  if (toAdd.year != undefined){
    nms += (toAdd.year*365*24*60*60*1000); //one year in milliseconds
  }
  if (toAdd.month != undefined){
    nms += (toAdd.month*30*24*60*60*1000); //one month = 30 days, in milliseconds
  }
  if (toAdd.day != undefined){
    nms += (toAdd.day*24*60*60*1000); //one year in milliseconds
  }
  if (toAdd.hour != undefined){
    nms += (toAdd.hour*60*60*1000); //one hour in milliseconds
  }
  if (toAdd.minute != undefined){
    nms += (toAdd.minute*60*1000); //one minute in milliseconds
  }
  if (toAdd.second != undefined){
    nms += (toAdd.second*1000); //one year in milliseconds
  }
  let jsd = getJSDate( date ).valueOf();
  let addd = setJSDate( nms + jsd );
  // console.log('nms adding '+nms, nms);
  // console.log('nms jsdate '+jsd, jsd);
  // console.log('nms totals '+addd, addd );
  return addd;
}

export function diffHours(dta, dtb){//returns the difference in hours
  let diff = getJSDate(dta).getTime() - getJSDate(dtb).getTime();
  diff = diff / (1000*60*60); //convert to hours
  return diff;
}

export function getJSDate( dt ){
  // console.log('getJSDate(', dt );
  if (dt.year < 2000){
    return new Date(dt.year+2000, dt.month-1, dt.day, dt.hour, dt.minute, dt.second, 0);
  } else {
    return new Date(dt.year, dt.month-1, dt.day, dt.hour, dt.minute, dt.second, 0);
  }
}
export function setJSDate( nMS1970 ){ //sets DateTime from js Milliseconds
  if (typeof(nMS1970) != 'number'){
    nMS1970 = parseInt(nMS1970);
  }
  // console.log('setJSDate( ' + typeof(nMS1970) , nMS1970 );
  let dt = new Date(nMS1970);
  // console.log('setJSDate( ' + nMS1970 , dt);
  return {
    year: dt.getFullYear(),
    month: dt.getMonth() +1, //JS Date has January = 0
    day: dt.getDate(),
    hour: dt.getHours(),
    minute: dt.getMinutes(),
    second: dt.getSeconds()
  }
}

export function dateTimeToString( dt ){
  return yearToString(dt.year) + monthToString(dt.month) + dayToString(dt.day);
}
//make things appear regular
function yearToString( year ){
  if (year < 0)
    return '??';
  if(2000 < year)
    return (year - 2000).toString();
  if (year < 10)
    return '0'+year.toString();
  return year.toString();
}
function monthToString(month){
  if (month < 1)
    return '??';
  if (month < 10)
    return '0'+month.toString();
  return month.toString();
}
function dayToString(day){
  if (day < 1 || 31 < day) // not checking 29/30/31 calendar
    return '??';
  if (day < 10)
    return '0'+day.toString();
  return day.toString();
}
function hourToString(hour){
  if (hour < 0)
    return '??';
  if (hour < 10)
    return '0'+hour.toString();
  return hour.toString();
}
function minuteToString(minute){
  if (minute < 0)
    return '??';
  if (minute < 10)
    return '0'+minute.toString();
  return minute.toString();
}
function secondToString(second){
  if (second < 0)
    return '??';
  if (second < 10)
    return '0'+second.toString();
  return second.toString();
}

